export default __webpack_public_path__ + "static/media/a2.f108fc90.jpg";